import React, {Component} from 'react';
import Team from './Team';

class Round1 extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    

    render() {
        var teams = this.props.teams;
        
        function getTransform(idx) {
            var angle = 360/64 * (idx+.5);

            // var width = window.innerWidth/2;
            var width = 900/2;
            var unit = width/12;
            var size = 11.5 * unit;
            return `translate(-50%,-50%) rotate(${angle}deg) translate(0,-${size}px) rotate(-${angle}deg)`;
        }
        
        return (
            <div className="round1 circle-wrapper">
                {teams.map((team,idx) => (
                    <div key={idx} className="team1" style={{transform:getTransform(idx)}}>
                        <Team 
                            onClick={this.props.onClick}
                            onHover={this.props.onHover}
                            team={team} 
                            round={1}
                            small></Team>
                    </div>
                ))}
            </div>
        );
    }
}

export default Round1;